import styled from 'styled-components';

export const BannerContainer = styled.div`
  position: relative;
  top: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 8px;
  border: 1px solid #ddeefa;
  border-radius: 12px;
  background: #f1f9fd;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.08);
  text-align: left;
  width: calc(100% + 40px);
  margin-left: -20px;
`;

const getOrder = position => {
  if (position === 'left') return 0;
  if (position === 'right') return 1;
  return undefined;
};

export const BannerImageWrapper = styled.div`
  ${({ order }) => {
    const orderValue = getOrder(order);
    return orderValue === undefined ? '' : `order: ${orderValue};`;
  }}
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 28px;
  height: auto;

  & img {
    max-width: 28px;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const BannerHeading = styled.h3`
  margin: 0;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #263b68;
`;

export const BannerText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #263b68;

  @media (min-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;
